module.exports = __webpack_public_path__ + "static/media/men.9f2fbb90.svg";